import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { AppText } from '../typography';
import { Box, Row } from '../layout';
import styled from '../../styles/styled';
export function TabsHeader({ tabs, activeTab, setActiveTab, isSmallScreen, dataTestId, }) {
    return (_jsx(Box, { minHeight: "1px", "data-testid": dataTestId, style: {
            paddingBottom: '16px',
        }, children: _jsx(TabsRow, { children: tabs.map(tab => (_jsx(Tab, { title: tab.title, isActive: activeTab === tab.key, onSelectNewTab: () => setActiveTab(tab.key), isSmallScreen: isSmallScreen }, tab.title))) }) }));
}
const TabsRow = styled(Row)(({ theme }) => ({
    display: 'inline-flex',
    position: 'sticky',
    top: '0',
    backgroundColor: theme.colors.white,
    width: '100%',
    zIndex: 1,
}));
const Tab = ({ title, isActive = false, onSelectNewTab, isSmallScreen }) => {
    return (_jsxs(TabWrapper, { onClick: onSelectNewTab, isActive: isActive, isSmallScreen: isSmallScreen, "data-testid": title, children: [_jsx(Row, { alignItems: 'center', minHeight: '35px', children: _jsx(AppText, { as: "h3", bold: true, color: isActive ? 'azure' : 'grey60', headingFontFamily: true, children: title }) }), isActive && _jsx(DecorativeUnderline, { isActive: isActive })] }));
};
const TabWrapper = styled.button(({ theme, isActive, isSmallScreen }) => ({
    padding: '0px',
    ':not(:first-of-type)': {
        marginLeft: isSmallScreen ? theme.spacing.s : theme.spacing.m,
    },
    ':not(:last-child)': {
        marginRight: isSmallScreen ? theme.spacing.s : theme.spacing.m,
    },
    ':hover': {
        cursor: 'pointer',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: 'none',
    background: 'none',
    'h3:not(:first-of-type)': {
        marginLeft: theme.spacing.s,
    },
    color: isActive ? theme.colors.azure : 'inherit',
}));
const DecorativeUnderline = styled.div(({ isActive, theme }) => ({
    marginTop: theme.spacing.s,
    marginBottom: '-1px',
    width: '100%',
    height: '2px',
    backgroundImage: isActive ? theme.gradients.lightGradient : 'none',
}));
//# sourceMappingURL=tabs_header.js.map